export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          了解蘑菇影视的平台理念与服务承诺
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-lg border border-background-200/60 p-6 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-shrink-0 w-20 h-20 rounded-2xl bg-primary-100 flex items-center justify-center">
                <span className="text-2xl font-heading font-bold text-primary-600">蘑</span>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                  蘑菇影视 — 让好内容触手可及
                </h3>
                <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    蘑菇影视成立于对优质影视内容的执着追求。我们相信，每一个人都应该能够轻松地观看自己喜欢的内容——无需复杂的注册流程，无需高昂的会员费用，无需繁琐的客户端安装。
                  </p>
                  <p>
                    平台覆盖电影、电视剧、综艺、动漫等多元内容类型，采用先进的自适应流媒体技术，确保在不同网络环境下都能提供高清流畅的播放体验。无论你使用的是手机还是电脑，都能享受到一致的观影品质。
                  </p>
                  <p>
                    我们的内容编辑团队每日精选推荐，从热播大片到冷门佳作，致力于帮助每一位观众发现值得一看的好内容。蘑菇影视不只是一个播放平台，更是一个连接观众与优秀影视作品的桥梁。
                  </p>
                  <p className="font-medium text-foreground-800">
                    免费 · 高清 · 不缓冲 —— 这是蘑菇影视对每一位观众的承诺。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}